import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { SharedService } from '@app/services/shared.service';
import { MiscellaneousModule } from '@app/modules/common/miscellaneous.module';
import { NotificationComponent } from '../common/notification/notification.component';
import { AssetSwiperControlComponent } from './assetswiper-control/assetswiper-control.component';
import { AutocompleteControlComponent } from './autocomplete-control/autocomplete-control.component';
import { ChartControlComponent } from './chart-control/chart-control.component';
import { DateControlComponent } from './date-control/date-control.component';
import { DialogComponent } from './dialog/dialog.component';

import { FileUploadComponent } from './file-upload/file-upload.component';
import { MatTableComponent } from './mat-table/mat-table.component';
import { MultiSelectControlComponent } from './multi-select-control/multi-select-control.component';
import { QuestionarieControlComponent } from './questionarie-control/questionarie-control.component';
import { RadioControlComponent } from './radio-control/radio-control.component';
import { StatusbarControlComponent } from './statusbar-control/statusbar-control.component';
import { StepperControlComponent } from './stepper-control/stepper-control.component';
import { TableControlComponent } from './table-control/table-control.component';
import { TextAreaControlComponent } from './textarea-control/textarea-control.component';
import { TooltipControlComponent } from './tooltip-control/tooltip-control.component';

import { DialogTitleComponent } from './dialog-title/dialog-title.component';
import { SelectOptionComponent } from './select-option/select-option.component';
import { TableComponent } from './table/table.component';
import { PaginationComponent } from './pagination/pagination.component';

export const sharedComponents = [
  NotificationComponent,
  AssetSwiperControlComponent,
  AutocompleteControlComponent,
  ChartControlComponent,
  DateControlComponent,
  DialogComponent,
  FileUploadComponent,
  MatTableComponent,
  MultiSelectControlComponent,
  QuestionarieControlComponent,
  RadioControlComponent,
  StatusbarControlComponent,
  StepperControlComponent,
  TableControlComponent,
  TextAreaControlComponent,
  TooltipControlComponent,
  DialogTitleComponent,
  SelectOptionComponent,
  TableComponent,
  PaginationComponent
]
@NgModule({
  imports: [MiscellaneousModule],
  declarations: [...sharedComponents],
  exports: [...sharedComponents],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  providers: [SharedService]
})
export class SharedComponentModule { }
